const ACTION_GET_GAS_METER_DETAIL = 'ACTION_GET_GAS_METER_DETAIL'
const ACTION_GET_GAS_METER_DETAIL_SUCCESS = 'ACTION_GET_GAS_METER_DETAIL_SUCCESS'
const ACTION_GET_GAS_METER_DETAIL_RESET = 'ACTION_GET_GAS_METER_DETAIL_RESET'

export {
  ACTION_GET_GAS_METER_DETAIL,
  ACTION_GET_GAS_METER_DETAIL_SUCCESS,
  ACTION_GET_GAS_METER_DETAIL_RESET,
}
